import Vue from 'vue'
import { CONTEXTS } from '@/config/constants'
import { ExternalCommunicationPlugin } from '@/services/external-communication/external-communication'
import { DynamicYieldClientPlugin } from '@/services/dynamic-yield-client'
import LazyLoadDirective from '@/directives/lazyload'
import DataTestIdDirective from '@/directives/data-test-id'
import MultiRefDirective from '@/directives/multi-ref'
import store from './vuex'
import { getI18nInstance } from './vue-i18n'
import './axios'
import './rollbar'
import { setupDynamicYieldClientListeners } from './dynamic-yield'

Vue.directive('lazyload', LazyLoadDirective)
Vue.directive('data-test-id', DataTestIdDirective)
Vue.directive('multi-ref', MultiRefDirective)

Vue.use(ExternalCommunicationPlugin)
Vue.use(DynamicYieldClientPlugin)
Vue.use({
  install(Vue) {
    Vue.prototype.$CONTEXTS = CONTEXTS
  },
})

Vue.filter('formattedCurrency', (number, locale, currency, minimumFractionDigits = 2) => {
  let result = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits,
  }).format(number)
  return result
})

setupDynamicYieldClientListeners()

async function newVue(params, callback) {
  const defaultOptions = {
    render: null, // Function to render the component: h => h(MyComponent)
    mount: null, // Selector to mount the vue instance in
  }
  const options = { ...defaultOptions, ...params }
  const vueOptions = {
    render: options.render,
    router: options.router,
    i18n: getI18nInstance(),
  }
  vueOptions.store = store
  const vm = new Vue(vueOptions)
  vm.$mount(options.mount)
  if (callback) callback(vm)

  return vm
}

export { Vue, newVue }
